<template>
  <div
    v-if="visible"
    class="delivery-date-help-modal__overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="deliveryDateHelpTitle"
    @click.self="emitClose"
  >
    <div class="delivery-date-help-modal__panel">
      <header class="delivery-date-help-modal__header">
        <h2
          id="deliveryDateHelpTitle"
          class="delivery-date-help-modal__title"
        >
          {{ $t('washRequestOnetime.help.title') }}
        </h2>
        <button
          type="button"
          class="delivery-date-help-modal__close"
          :aria-label="$t('common.close')"
          @click="emitClose"
        >
          ×
        </button>
      </header>

      <section
        v-for="section in sections"
        :key="section.key"
        class="delivery-date-help-modal__section"
      >
        <h3 class="delivery-date-help-modal__section-title">
          {{ section.title }}
        </h3>
        <p class="delivery-date-help-modal__section-body">
          {{ section.body }}
        </p>
      </section>

      <footer class="delivery-date-help-modal__footer">
        <p class="delivery-date-help-modal__footer-note">
          {{ $t('washRequestOnetime.help.sundayUnavailableNote') }}
        </p>
      </footer>
    </div>
  </div>
</template>

<script>
const SECTION_KEYS = ['sameDay', 'nextDay', 'twoDaysLater'];

export default {
  name: 'DeliveryDateHelpModal',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close'],
  computed: {
    sections() {
      return SECTION_KEYS.map((key) => ({
        key,
        title: this.$t(`washRequestOnetime.help.${key}.title`),
        body: this.$t(`washRequestOnetime.help.${key}.body`),
      }));
    },
  },
  watch: {
    visible(next) {
      if (next === true) {
        document.addEventListener('keydown', this.onKeydown);
        return;
      }
      document.removeEventListener('keydown', this.onKeydown);
    },
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    emitClose() {
      this.$emit('close');
    },
    onKeydown(event) {
      if (event.key !== 'Escape') {
        return;
      }
      this.emitClose();
    },
  },
};
</script>

<style lang="scss" scoped>
.delivery-date-help-modal {
  &__overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    animation: deliveryDateHelpModalFadeIn 0.18s ease-out;
  }

  &__panel {
    background-color: #fff;
    border-radius: 8px;
    width: min(560px, calc(100vw - 32px));
    max-height: calc(100vh - 64px);
    overflow-y: auto;
    padding: 24px;
    box-sizing: border-box;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  &__title {
    font-size: 18px;
    font-weight: 700;
    margin: 0;
  }

  &__close {
    background: none;
    border: none;
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
    padding: 4px 8px;
    min-width: 44px;
    min-height: 44px;
  }

  &__section {
    margin-bottom: 16px;
  }

  &__section-title {
    font-size: 15px;
    font-weight: 700;
    margin: 0 0 4px;
  }

  &__section-body {
    font-size: 14px;
    line-height: 1.6;
    margin: 0;
    white-space: pre-line;
  }

  &__footer {
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px solid #ddd;
  }

  &__footer-note {
    font-size: 14px;
    color: #e53935;
    margin: 0;
  }
}

@keyframes deliveryDateHelpModalFadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}
</style>
